{
  "entry": {
    "title": "처방 입력",
    "subtitle": "전산화 처방 입력(CPOE)",
    "searchSection": {
      "title": "처방 검색 및 추가",
      "cosignNotice": "귀하의 처방은 활성화 전에 주치의의 부서명이 필요합니다."
    },
    "pending": {
      "title": "대기 중인 처방",
      "clearAll": "모두 지우기",
      "collapseAria": "세부 정보 접기",
      "expandAria": "세부 정보 펼치기",
      "removeAria": "처방 제거",
      "startDateTime": "시작 일시",
      "ariaStartDate": "처방 시작 날짜",
      "ariaStartTime": "처방 시작 시간",
      "clinicalIndication": "임상 적응증",
      "clinicalIndicationPlaceholder": "처방 사유…",
      "specialInstructions": "특별 지시",
      "specialInstructionsPlaceholder": "수행 부서에 대한 추가 지시…",
      "diagnosisLabel": "진단(ICD-10)",
      "diagnosisPlaceholder": "ICD-10 진단 코드 검색…",
      "noActiveEncounter": "활성 진료 없음 — 처방을 발행할 수 없습니다.",
      "placing": "전송 중…",
      "placeAll": "모든 처방 전송({{count}})"
    },
    "active": {
      "title": "활성 처방",
      "loading": "처방을 불러오는 중…",
      "emptyAll": "이 환자에 대한 처방을 찾을 수 없습니다.",
      "emptyFiltered": "{{type}} 처방을 찾을 수 없습니다.",
      "columns": {
        "orderNumber": "처방 번호",
        "name": "이름",
        "type": "유형",
        "priority": "우선순위",
        "status": "상태",
        "orderedBy": "처방의",
        "orderedDate": "처방 일자",
        "actions": "작업"
      },
      "external": "외부",
      "externalTitle": "{{source}}의 외부 처방",
      "externalTitleWithId": "{{source}}의 외부 처방 (#{{id}})",
      "providerPlaceholder": "의사 #{{id}}",
      "actions": {
        "complete": "완료",
        "cancel": "취소",
        "completeTooltip": "처방 완료",
        "cancelTooltip": "처방 취소"
      }
    },
    "cancelDialog": {
      "title": "처방 취소",
      "prompt": "{{orderName}} 취소 사유를 입력하세요.",
      "placeholder": "취소 사유(필수)…",
      "goBack": "뒤로",
      "confirm": "취소 확인"
    },
    "toast": {
      "cancelSuccess": "처방이 성공적으로 취소되었습니다",
      "cancelError": "처방 취소에 실패했습니다",
      "completeSuccess": "처방이 완료로 표시되었습니다",
      "completeError": "처방 완료에 실패했습니다",
      "noActiveEncounter": "이 환자의 활성 진료를 찾을 수 없습니다. 먼저 진료를 생성하세요.",
      "placedSuccess_one": "{{count}}건의 처방이 성공적으로 전송되었습니다",
      "placedSuccess_other": "{{count}}건의 처방이 성공적으로 전송되었습니다",
      "medicationFieldsRequired_one": "{{names}}을(를) 처방하려면 용량, 투여 경로, 투여 빈도가 필요합니다",
      "medicationFieldsRequired_other": "{{count}}개 약물에 용량, 투여 경로, 투여 빈도가 필요합니다: {{names}}",
      "medicationNotInFormulary_one": "{{names}}은(는) 처방집에 연결되지 않아 알레르기·상호작용·용량을 확인할 수 없습니다. 약물 페이지에서 처방하세요",
      "medicationNotInFormulary_other": "{{count}}개 약물이 처방집에 연결되지 않아 확인할 수 없습니다: {{names}} — 약물 페이지에서 처방하세요",
      "placedError_one": "{{count}}건의 처방 전송이 실패했습니다",
      "placedError_other": "{{count}}건의 처방 전송이 실패했습니다",
      "orderSetApplied": "'{{name}}'에서 처방 {{count}}건을 추가했습니다 — 서명 전 검토하세요"
    }
  },
  "catalog": "처방 목록",
  "orderedBy": "처방의",
  "orderedDate": "처방일",
  "scheduledDate": "예정일",
  "completedDate": "완료일",
  "lab": "검체 검사",
  "imaging": "영상 검사",
  "medication": "약물",
  "procedure": "시술",
  "consultation": "자문",
  "priority": {
    "label": "우선순위",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "긴급",
      "routine": "정기",
      "scheduled": "예약",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "처방 상태",
    "values": {
      "draft": "초안",
      "pending": "보류",
      "pendingCosign": "부서명 대기",
      "signed": "서명됨",
      "sent": "전송됨",
      "active": "활성",
      "ordered": "처방 완료",
      "inProgress": "진행 중",
      "holdForVerify": "확인 대기",
      "completed": "완료",
      "cancelled": "취소됨",
      "discontinued": "중단",
      "archived": "보관됨",
      "pendingClarification": "확인 대기",
      "suspended": "보류",
      "unknown": "알 수 없음"
    }
  },
  "entryFields": {
    "searchPlaceholder": "처방 검색(검사·영상·약물·시술)…",
    "frequency": "투약 빈도",
    "dose": "용량",
    "route": "투여 경로",
    "indication": "적응증",
    "duration": "기간",
    "comments": "비고",
    "signOrder": "처방 서명",
    "holdOrder": "처방 보류",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "처방 목록",
    "searchPlaceholder": "이름·코드·동의어로 검색…",
    "categories": "분류",
    "favorites": "즐겨찾기",
    "recentlyUsed": "최근 사용",
    "restricted": "제한 항목",
    "searchCatalog": "목록 검색",
    "tabs": {
      "all": "전체",
      "lab": "검사",
      "imaging": "영상",
      "medication": "약물",
      "procedure": "시술",
      "consultation": "자문"
    },
    "columns": {
      "orderName": "처방명",
      "code": "코드",
      "category": "분류",
      "description": "설명",
      "defaultPriority": "기본 우선순위"
    },
    "details": {
      "orderCode": "처방 코드",
      "category": "분류",
      "defaultPriority": "기본 우선순위",
      "status": "상태",
      "cptCode": "CPT 코드",
      "loincCode": "LOINC 코드",
      "synonyms": "동의어",
      "description": "설명",
      "active": "활성",
      "inactive": "비활성"
    },
    "loading": "목록을 불러오는 중…",
    "loadError": "처방 목록을 불러오지 못했습니다",
    "emptyResults": "조건에 맞는 처방이 없습니다.",
    "pagination": "전체 {{total}}건 중 {{from}}-{{to}}건 표시",
    "pageIndicator": "{{totalPages}} 페이지 중 {{page}} 페이지",
    "favoriteAdd": "즐겨찾기에 추가",
    "favoriteRemove": "즐겨찾기에서 제거",
    "favoriteAdded": "즐겨찾기에 추가되었습니다",
    "favoriteRemoved": "즐겨찾기에서 제거되었습니다"
  },
  "cosign": {
    "title": "처방 공동서명 큐",
    "requiresCosign": "공동서명 필요",
    "cosignedBy": "공동서명자",
    "cosignDeadline": "공동서명 기한",
    "queueEmpty": "공동서명이 필요한 처방이 없습니다.",
    "pendingCount": "대기 {{count}}건",
    "loading": "공동서명 큐를 불러오는 중…",
    "loadError": "공동서명 큐를 불러오지 못했습니다.",
    "columns": {
      "patient": "환자",
      "order": "처방",
      "type": "유형",
      "orderingProvider": "처방의",
      "priority": "우선순위",
      "orderedDate": "처방일",
      "action": "작업"
    },
    "actions": {
      "cosign": "공동서명"
    },
    "toast": {
      "success": "처방을 공동서명했습니다",
      "error": "처방 공동서명에 실패했습니다"
    },
    "cosigningAs": "{{name}}(으)로 공동서명"
  },
  "sets": {
    "title": "처방 세트",
    "newOrderSet": "새 처방 세트",
    "addItem": "항목 추가",
    "requiredItem": "필수",
    "optionalItem": "선택",
    "editMode": "편집 모드",
    "published": "게시됨",
    "draft": "초안",
    "archived": "보관됨",
    "versionNotes": "버전 메모",
    "createTitle": "새 처방 세트 만들기",
    "fields": {
      "name": "이름",
      "category": "분류",
      "specialty": "전문 분야",
      "description": "설명"
    },
    "placeholders": {
      "name": "예: 흉통 정밀검사",
      "categorySelect": "분류 선택…",
      "specialty": "예: 응급의학",
      "description": "간단한 설명…",
      "search": "처방 세트 검색…"
    },
    "categories": {
      "chestPain": "흉통",
      "sepsis": "패혈증",
      "postOp": "수술 후",
      "admission": "입원",
      "discharge": "퇴원",
      "other": "기타"
    },
    "statusFilter": {
      "all": "모든 상태",
      "active": "활성",
      "draft": "초안",
      "archived": "보관됨"
    },
    "columns": {
      "name": "이름",
      "category": "분류",
      "specialty": "전문 분야",
      "items": "항목 수",
      "status": "상태",
      "version": "버전",
      "actions": "작업"
    },
    "itemColumns": {
      "seq": "순번",
      "type": "유형",
      "item": "항목",
      "priority": "우선순위",
      "required": "필수"
    },
    "itemTypes": {
      "order": "처방",
      "sectionHeader": "섹션 머리글",
      "instruction": "지시 사항"
    },
    "actions": {
      "publish": "게시",
      "archive": "보관",
      "cancel": "취소",
      "create": "만들기",
      "removeItem": "항목 제거"
    },
    "loading": "처방 세트를 불러오는 중…",
    "loadError": "처방 세트를 불러오지 못했습니다",
    "emptyResults": "처방 세트가 없습니다.",
    "expandLoading": "항목을 불러오는 중…",
    "expandEmpty": "이 처방 세트에는 항목이 없습니다.",
    "validationRequired": "이름·분류·전문 분야는 필수 항목입니다",
    "toast": {
      "created": "처방 세트를 만들었습니다",
      "createError": "처방 세트 생성에 실패했습니다",
      "published": "처방 세트를 게시했습니다",
      "publishError": "처방 세트 게시에 실패했습니다",
      "archived": "처방 세트를 보관했습니다",
      "archiveError": "처방 세트 보관에 실패했습니다",
      "itemRemoved": "항목을 제거했습니다",
      "itemRemoveError": "항목 제거에 실패했습니다"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "처방 검색(검사·영상·약물·시술)…",
    "noResults": "\"{{query}}\"에 해당하는 처방이 없습니다",
    "categories": {
      "all": "전체",
      "lab": "검사",
      "imaging": "영상",
      "med": "약물",
      "procedure": "시술",
      "consultation": "협진"
    },
    "addAll": "모두 추가 ({{count}})"
  },
  "worklist": {
    "title": "오더 작업 목록",
    "countBadge": "오더 {{count}}건",
    "loading": "오더를 불러오는 중…",
    "loadError": "오더를 불러올 수 없습니다. 다시 시도해 주세요.",
    "empty": "현재 필터와 일치하는 오더가 없습니다.",
    "typeLabel": "오더 유형",
    "allOption": "전체",
    "columns": {
      "patient": "환자",
      "order": "오더",
      "type": "유형",
      "priority": "우선순위",
      "status": "상태",
      "ordered": "처방일시"
    }
  }
}
